import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom';

import 'moment/locale/it';
import 'font-awesome/css/font-awesome.min.css';
import './index.scss';
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import { nazioni } from './lang/nazioni';
Amplify.configure(awsconfig);

const { theme } = store.getState();
const n = nazioni.filter(n => n.isoAlpha2 == theme.language.toUpperCase());

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<HashRouter>
				<App />
			</HashRouter>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
